function slice(csv, a, b) {
    return csv.map((row) => {
        return row.slice(a, b)
    })
}

function unheader(csv) {
    const headers = csv.shift()

    csv.forEach((row) => {
        headers.forEach((header, index) => {
            row[header] = row[index]
        })
    })

    return csv
}

const WORLD_WIDTH = 6
const WORLD_HEIGHT = 6
const WORLD_DEPTH = 4

export function parseWorld(protoworld) {
    const world = {
        "width": WORLD_WIDTH,
        "height": WORLD_HEIGHT,
        "depth": WORLD_DEPTH,
        "blocks": [],
        "edges": {},
        "terrain": {},
        "key": protoworld[0][7]
    }
    let victory = {
        "condition": "annihilate"
    }
    for(let x = 0; x < WORLD_WIDTH; x += 1) {
        for(let y = 0; y < WORLD_HEIGHT; y += 1) {
            const tile = protoworld[y][x]
            const z = Number.parseFloat(tile)
            world.terrain[x + "x" + y] = {
                "position": {x, y, z},
                "shape": "block",
            }

            ////////////
            // EDGES //
            //////////

            // format for edges:
            // "1x0x1/-1x0": {"position": {"x": 1, "y": 0, "z": 1}, "direction": "west"},
            // "1x0x1/+1x0": {"position": {"x": 1, "y": 0, "z": 1}, "direction": "east"},
            // "1x0x1/0x-1": {"position": {"x": 1, "y": 0, "z": 1}, "direction": "north"},
            // "1x2x1/+1x0": {"position": {"x": 1, "y": 2, "z": 1}, "direction": "east"},
            // "1x3x1/+1x0": {"position": {"x": 1, "y": 3, "z": 1}, "direction": "east"},
            if(tile.includes("e")) world.edges[x + "x" + y + "x" + z + "/+1x0"] = {"position": {x, y, z}, "direction": "east"}
            if(tile.includes("w")) world.edges[x + "x" + y + "x" + z + "/-1x0"] = {"position": {x, y, z}, "direction": "west"}
            if(tile.includes("n")) world.edges[x + "x" + y + "x" + z + "/0x-1"] = {"position": {x, y, z}, "direction": "north"}
            if(tile.includes("s")) world.edges[x + "x" + y + "x" + z + "/0x+1"] = {"position": {x, y, z}, "direction": "south"}

            if(tile.includes("v")) {
                if(victory.condition != "escape") {
                    victory.condition = "escape"
                    victory.affiliation = "good"
                    victory.positions = []
                }
                victory.positions.push({x, y, z})
            }

            if(tile.includes("o")) {
                world.terrain[x + "x" + y].shape = "obstruction"
            }
        }
    }
    return {world, victory}
}

const elements = {
    "Fire": "fire",
    "Grass": "grass",
    "Leaf": "grass",
    "Wood": "grass",
    "Water": "water",
    "Ground": "ground",
    "Rock": "ground",
    "Metal": "metal",
    "Lightning": "lightning",
    "Electric": "lightning",
    "Normal": "neutral",
    "Neutral": "neutral",
}
const ASSET_DOMAIN = "https://frog-tactics.s3-us-west-2.amazonaws.com"
export function parseUnit(protounit) {
    if(protounit.length == 0
    || protounit.every((value) => value == "")) {
        return undefined
    }
    const unit = {}

    if(protounit["Reference"] !== undefined) {
        unit["reference"] = protounit["Reference"]
    }
    // "name": protounit["Name"],
    // // "displayName": protounit["Name"],
    // "number": Number.parseInt(protounit["Number"]) || 0,
    // "element": elements[protounit["Element 1"]] || "neutral",
    // "power": Number.parseInt(protounit["Power"]),
    // unit["moverange"] = Number.parseInt(protounit["Move Range"])
    // "maxlevel": Number.parseInt(protounit["Max Level"]),
    // let paddednumber = (unit.number < 100 ? "0" : "") + (unit.number < 10 ? "0" : "") + (unit.number || 0)
    // unit.image = ASSET_DOMAIN + "/assets/images/pokemon/oakdex/" + paddednumber + ".png"
    // unit.image = require("@frog/source/assets/images/pokemon/oakdex/" + paddednumber + ".png") // DEBUG
    // if(unit.reference == "A") unit.image = require("@frog/source/images/tamer.png")

    // unit["family"] = protounit["Family"].toLowerCase()
    // unit["level"] = Number.parseInt(protounit["Level"])
    // unit["power"] = Number.parseInt(protounit["Power"]) || 0

    unit["affiliation"] = protounit["Affiliation"]
    // unit["maxhealth"] = Number.parseInt(protounit["Health"])
    // unit["skills"] = [protounit["Skill 1"], protounit["Skill 2"], protounit["Skill 3"]].filter((skill) => !!skill)

    const position = protounit["Position"].split("x")
    unit["position"] = {"x": parseInt(position[0]), "y": parseInt(position[1]), "z": 1} // TODO: this is hardcoded to z=1
    unit["turn"] = protounit["Turn"]

    // if(unit.reference != undefined) {
    //     units[unit.reference] = unit
    // }
    // units["number:" + unit.number] = unit
    // units["name:" + unit.name.toLowerCase()] = unit
    //
    // units["family:" + unit.family + "/level:" + unit.level] = unit
    //
    // units["all"] = units["all"] || []
    // units["all"].push(unit)

    return unit
}

export function parseEncounter(protoencounter) {
    const protoworld = slice(protoencounter, 0, 6)
    const protounits = unheader(slice(protoencounter, 7))

    const {world, victory} = parseWorld(protoworld)
    const units = []
    const events = {}

    protounits.forEach((protounit) => {
        const unit = parseUnit(protounit)

        if(unit == undefined) {
            return
        }

        if(unit.turn == 0) {
            units.push(unit)
        } else {
            events[unit.turn + ":end"] = events[unit.turn + ":end"] || []
            events[unit.turn + ":end"].push({
                "type": "spawn",
                "unit": unit
            })
        }
    })
    for(let x = 0; x < WORLD_WIDTH; x += 1) {
        for(let y = 0; y < WORLD_HEIGHT; y += 1) {
            const tile = protoworld[y][x]
            if(tile.includes("+")) {
                // TODO: this should be a prefab by reference.
                units.push({
                    "position": {x, y, "z": parseInt(tile)},
                    "reference": "box",
                    // "health": 1,
                    // "maxhealth": 1,
                    // "range": 0,
                    // "power": 0,
                    // "skills": [],
                    "affiliation": "none",
                })
            }
        }
    }

    return {
        "type": "combat",
        "stage": {
            victory,
            units,
            world,
            events,
        }
    }
}
